import React, { useState } from "react";

import { Button } from "react-bootstrap";
import planIcon from "../Assets/Images/PlanIcon.png";

import PackIcon from "../Assets/Images/user-pack.svg";
import wpIcon from "../Assets/Images/wp-plugin.svg";
import cCardIcon from "../Assets/Images/cc-card.svg";

const PlanInfo = (props) => {
  const { selected, onSelect, id, iconColor, title, seats, monthly, pricePerSeat } =
    props;
  const classSelected = selected === id ? "selected" : "";
  const buttonText = selected === id ? "Selected" : "Select";
  return (
    <div className="plan-card">
      <div className="plan-card-header" style={{backgroundColor: iconColor,}}>
        <img src={planIcon} />
      </div>
      <div className="plan-card-body">
        <h4>{title}</h4>
        <p className="plan-description"><img src={PackIcon} /> {`Package of ${seats} seats`}</p>
        <p className="plan-description"><img src={wpIcon} /> {`Web Widget and Archive Portal`}</p>
        <p className="plan-description"><img src={cCardIcon} /> {`Monthly Payment: $${monthly}`}</p>
        <h4 className="price-per-seat">
          {pricePerSeat}
          <text className="text-per-seat">per seat</text>
        </h4>

        <Button
          className={`select-plan ${classSelected}`}
          onClick={() => onSelect(id)}
        >
          {buttonText}
        </Button>
      </div>
    </div>
  );
};
export default PlanInfo;
